import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { createRecipeStyles } from "./styles";
import { MaterialPropertiesIcon } from "../ui/RecipeIcons";
import { PropertyGroup } from "../../types/recipe";

/**
 * Props for RecipeMaterialProperties component.
 * @property {any[]} filteredProperties - Array of filtered material property objects.
 */
interface RecipeMaterialPropertiesProps {
  filteredProperties: any[];
}

const RecipeMaterialProperties: React.FC<RecipeMaterialPropertiesProps> = ({
  filteredProperties,
}) => {
  const theme = useTheme();
  const styles = createRecipeStyles(theme);

  // Filter out properties that are empty or have invalid values
  const validProperties = filteredProperties.filter(
    (item) =>
      item &&
      typeof item.name === "string" &&
      Array.isArray(item.items) &&
      item.items.length > 0 &&
      item.items[0] &&
      item.items[0].value !== undefined &&
      item.items[0].value !== null &&
      item.items[0].value !== ""
  );

  return (
    <Paper elevation={0} sx={styles.page.sectionCard}>
      {/* Section header with icon and title */}
      <Box sx={styles.page.sectionHeader}>
        <MaterialPropertiesIcon />
        <Typography variant="h5" sx={styles.page.sectionTitle}>
          Material Properties
        </Typography>
      </Box>
      {/* Render valid properties or empty state */}
      {validProperties.length > 0 ? (
        <Box sx={styles.page.propertiesList}>
          {validProperties.map((item, key) => (
            <Box key={key} sx={styles.page.propertyRow}>
              {/* Property name */}
              <Typography variant="subtitle2" sx={styles.page.propertyLabel}>
                {item.name || "Unnamed Property"}
              </Typography>
              {/* Property value and unit */}
              <Typography variant="body2" sx={styles.page.propertyValue}>
                {item.items[0].value ?? "N/A"} {item.items[0].unit ?? ""}
              </Typography>
            </Box>
          ))}
        </Box>
      ) : (
        // Empty state if no valid properties
        <Box sx={styles.page.propertiesList} />
      )}
    </Paper>
  );
};

export default RecipeMaterialProperties;
